var map = {
	"./back-primary.png": 61824,
	"./back-primary@2x.png": 79707,
	"./back-primary@3x.png": 40755,
	"./back-secondary.png": 62528,
	"./back-secondary@2x.png": 19336,
	"./back-secondary@3x.png": 52115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88144;